import { initVWO } from './boot-vwo';

export function installOneTrustHook() {
    const checkOneTrustConsent = () => {
        if (typeof window.OptanonActiveGroups === 'undefined') return;

        const cookiePerformance = 'C0002';

        if (window.OptanonActiveGroups.includes(cookiePerformance)) {
            initVWO();
        } else {
            window.VWO_OUTCOME = 'regular';
        }
    };

    window.addEventListener('consent.onetrust', checkOneTrustConsent);
}
